export const currency = {
  format: (str = "", digits = 2) => {
    return intlFormatter(digits).format(
      String(str)?.replace(/[^0-9.-]/g, "") ?? 0
    );
  },
};
export const intlFormatter = (digits = 2) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: digits,
  });

export const percentage = (digits) =>
  new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: digits,
  });

export const formattedNumber = (
  number = 0,
  minimumFractionDigits = 0,
  maximumFractionDigits = 0,
  style = "decimal"
) => {
  return number.toLocaleString(undefined, {
    style: style,
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits,
  });
};
